




































































































































import Vue from 'vue';
// import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';
import AgregarConcepto from '@/components/conceptos/AgregarConcepto.vue';

export default Vue.extend({
  components: { AgregarConcepto },
  data: () => ({
    singleSelect: false,
    row: {},
    selected: [],
    headers: [
      { text: 'Concepto', value: 'nombre' },
      // { text: 'conceptoId', value: 'id' },
      { text: 'Cuenta Contable', value: 'ctaContable' },
      { text: 'Tipo', value: 'tipo' },
      { text: 'Descripción', value: 'descripcion' },
      { text: 'Observaciones', value: 'observaciones' },
      { text: 'Estado', value: 'enabled'},
    ],
    total: 0,
    Conceptos: [],
    loading: true,
    options: {
      sortBy: ['nombre'],
      sortDesc: [false],
    },
    dialog: false,
    Concepto: { enabled: true },
    readonly: true,
    confirmationDialog: false,
    // enabled: true,
  }),
  methods: {
    ...mapActions(['getConceptoList']),
    open(event) {
      console.log('Current:', event);
      this.Concepto = event;
      this.dialog = true;
      this.readonly = true;
    },
    rowSelected(event) {
      this.open(event);
    },
    async loadData() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        this.loading = true;
        const result = await this.$store.dispatch('getConceptoListAll', {admin, condo, options: this.options});
        console.debug('getConceptoList result: %o', result);
        this.total = result.totalElements;
        this.Conceptos = result.content;
        console.log('CONCEPTO: %o', this.Conceptos);
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async updateConcept() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const concept = this.Concepto;
      const result = await this.$store.dispatch('updateConcept', {admin, condo, concept});
      console.debug('UpdateConcept-result: ', result);
      this.dialog = false;
      this.$toast.success(`Concepto ${this.Concepto.nombre} modificado`);
      this.loadData();
    },
    async deleteConcepto() {
      try {
        this.loading = true;
        const concepto = this.Concepto.id;
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        const result = await this.$store.dispatch('deleteConcepto', {condo, concepto} );
        console.debug('Respuesta DeletePropietCondo: %o', result);
        this.$toast.success('Concepto Eliminado');
        this.confirmationDialog = false;
        this.dialog = false;
        this.dialog = false;
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response.data.message);
      }
      this.loading = false;
      this.loadData();
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
  },
});
